import React from 'react';
import { CheckIcon } from 'lucide-react';
import { IMAGES } from '../data/content';
import { CTAButton } from './CTAButton';
const checks = ['One-time payment', 'Instant digital access', 'Lifetime access', '7-day money-back guarantee'];
export function FinalCTA() {
  return <section className="w-full bg-navy px-4 py-14 text-white md:py-20" data-id="element-103" data-mp="85fdz4vta14v">
      <div className="mx-auto max-w-4xl text-center" data-id="element-104" data-mp="87a20s2dq9d6">
        <h2 className="font-display text-[2.2rem] font-extrabold uppercase leading-[1.02] sm:text-6xl" data-id="element-105" data-mp="m3wxeqeoorgz">
          Ready to approach pediatric orthodontic cases with a <span className="text-gold" data-id="element-106" data-mp="h411leg546ci">clearer framework?</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-relaxed text-white/80" data-id="element-107" data-mp="vtyl3h34k7vd">
          Stop searching through scattered references every time you review a clinical concept. Six specialized volumes
          and five complementary resources to organize your assessments, compare alternatives, and structure your
          reasoning.
        </p>
        <img src={IMAGES.mockup} alt="" className="-mx-4 mt-8 w-[calc(100%+2rem)] max-w-none sm:mx-auto sm:w-full sm:max-w-2xl" loading="lazy" data-id="element-108" data-mp="2c56hmm3ph1ru" />
        <p className="mt-6 font-display text-3xl font-extrabold uppercase text-white sm:text-4xl" data-id="element-109" data-mp="2h3zs05np4cns">
          All 6 volumes + 5 bonuses for just <span className="text-gold" data-id="element-110" data-mp="2r1np328rxw94">$27 USD</span>
        </p>
        <ul className="mx-auto mt-6 grid max-w-md grid-cols-2 gap-3 text-left" data-id="element-111" data-mp="2r38lkxenfp9m">
          {checks.map(c => <li key={c} className="flex items-center gap-2 text-sm font-medium" data-id="element-112" data-mp="2v1fyfh5zs6fj">
              <CheckIcon className="h-4 w-4 shrink-0 text-teal-light" strokeWidth={3} aria-hidden="true" data-id="element-113" data-mp="300snm8kc5pla" />
              {c}
            </li>)}
        </ul>
        <CTAButton className="mt-8" tone="dark" label="Yes! I want the blueprint" subtext="Only $27 USD · Instant access · One-time payment" data-id="element-114" data-mp="39sootshpxvtq" />
        <p className="mx-auto mt-8 max-w-2xl text-xs leading-relaxed text-white/50" data-id="element-115" data-mp="3epf1e5ube9ae">
          Educational resource for dental professionals. Clinical decisions must be based on an individualized patient
          assessment, current evidence, professional judgment, and applicable standards of care.
        </p>
      </div>
    </section>;
}